.container {
  overflow: auto;
}

.divider {
  margin-top: 8px;
  margin-bottom: 8px;
}
